
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDriverStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"averageOverviewStats"},"name":{"kind":"Name","value":"averageDriverStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryNotesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distanceTravelled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveriesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"failedDeliveriesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageDeliveryManCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuelConsumption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuelConsumptionPerKm"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"averageScheduleStats"},"name":{"kind":"Name","value":"averageDriverStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaveCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nearTrips"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mediumTrips"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"farTrips"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extraTrips"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"driver"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"overviewStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryNotesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distanceTravelled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveriesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"failedDeliveriesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"satisfaction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageDeliveryManCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuelConsumption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuelConsumptionPerKm"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"scheduleStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaveCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nearTrips"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mediumTrips"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"farTrips"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extraTrips"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":975}};
    doc.loc.source = {"body":"query getDriverStats(\n  $id: ID!\n  $year: Int\n  $month: Int\n) {\n  averageOverviewStats: averageDriverStats (\n    year: $year\n    month: $month\n  ) {\n    deliveryNotesCount\n    distanceTravelled\n    deliveriesCount\n    failedDeliveriesCount\n    satisfaction\n    averageDeliveryManCount\n    fuelConsumption\n    fuelConsumptionPerKm\n  }\n  averageScheduleStats: averageDriverStats (\n    year: $year\n    month: $month\n  ) {\n    leaveCount\n    nearTrips\n    mediumTrips\n    farTrips\n    extraTrips\n  }\n  driver (\n    id: $id\n  ) {\n    id\n    overviewStats: stats (\n      year: $year\n      month: $month\n    ) {\n      deliveryNotesCount\n      distanceTravelled\n      deliveriesCount\n      failedDeliveriesCount\n      satisfaction\n      averageDeliveryManCount\n      fuelConsumption\n      fuelConsumptionPerKm\n    }\n    scheduleStats: stats (\n      year: $year\n      month: $month\n    ) {\n      leaveCount\n      nearTrips\n      mediumTrips\n      farTrips\n      extraTrips\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getDriverStats"] = oneQuery(doc, "getDriverStats");
        
